import React from "react";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import { gaEventCats } from "../../config/config";
import {
  DropdownIcon,
  NavbarActiveWalletIcon,
  NavbarWalletIcon,
} from "../../foundations/icon";
import sendGaEvent from "../../services/sendGaEvent";
import SidebarItemText from "./SidebarItemText";
import PropTypes from "prop-types";
import getSubItemStyle from "../../utils/getSubItemStyle";
import useHandleNavlinkClick from "../../hooks/useHandleNavlinkClick";
import useUserSettings from "../../contexts/UserSettingsProvider";

export default function WalletNavLink({
  isEachWalletItemVisible,
  toggleIsEachWalletItemVisible,
}) {
  const { t } = useTranslation();
  const { handleNavlinkClick } = useHandleNavlinkClick(gaEventCats.sidebar);
  const { isSidebarOpen } = useUserSettings();

  return (
    <>
      <div
        className={`wallet flex items-center mt-8 ${
          !isSidebarOpen ? "justify-center" : "justify-between"
        }`}
      >
        <NavLink
          to="/wallet"
          className="flex items-center cursor-pointer w-full"
          onClick={() => sendGaEvent(gaEventCats.sidebar, "NavToWallet")}
        >
          {({ isActive }) => (
            <>
              <div
                className={`  ${
                  isSidebarOpen ? "2xl:mr-4 mr-2" : "w-full flex justify-center"
                } cursor-pointer `}
              >
                {isActive ? <NavbarActiveWalletIcon /> : <NavbarWalletIcon />}
              </div>
              <SidebarItemText
                isActive={isActive}
                text="myWallet"
                isSidebarOpen={isSidebarOpen}
              />
            </>
          )}
        </NavLink>
        {isSidebarOpen ? (
          <div
            className="self-center cursor-pointer"
            onClick={toggleIsEachWalletItemVisible}
          >
            <DropdownIcon />
          </div>
        ) : null}
      </div>
      {isSidebarOpen && isEachWalletItemVisible ? (
        <>
          <div className="flex flex-col gap-3 pt-1">
            <NavLink
              to="/wallet/deposit"
              className={({ isActive }) =>
                `deposit ${getSubItemStyle(isActive)}`
              }
              onClick={() => handleNavlinkClick("NavToDeposit")}
            >
              {t("deposit")}
            </NavLink>
            <NavLink
              to="/wallet/withdraw"
              className={({ isActive }) =>
                `withdraw ${getSubItemStyle(isActive)}`
              }
              onClick={() => handleNavlinkClick("NavToWithdraw")}
            >
              {t("withdraw")}
            </NavLink>
            <NavLink
              to="/wallet/transactions"
              className={({ isActive }) => getSubItemStyle(isActive)}
              onClick={() => handleNavlinkClick("NavToTransactions")}
            >
              {t("transactions")}
            </NavLink>
          </div>
        </>
      ) : null}
    </>
  );
}

WalletNavLink.propTypes = {
  isEachWalletItemVisible: PropTypes.bool.isRequired,
  toggleIsEachWalletItemVisible: PropTypes.func.isRequired,
};
